import React from 'react';
import { cn } from '../../utils/cn';

/**
 * GradientText - Text with animated gradient
 * Used to highlight key words and phrases
 *
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Text content
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {boolean} [props.animated=false] - Enable gradient animation
 */
const GradientText = ({
  children,
  className = '',
  animated = false
}) => {
  return (
    <span
      className={cn(
        'text-gradient',
        animated && 'animate-gradient',
        className
      )}
      style={{
        background: 'var(--gradient-primary)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}
    >
      {children}
    </span>
  );
};

export default GradientText;
